<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Workflows'"
      [canGoBack]="true"
      [customBack]="'more'" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>


    @if (errorMessage) {
      <tidy-error-message
        [text]="errorMessage" />
    }

    @if (loaded) {
      <tidy-row [alignLastItemRight]="true">
        <tidy-text
          [body]="isSavingChange ? 'Saving Changes..' : 'All Changes Saved.'" />
        <tidy-text
          [actionBody]="'Add Workflow'"
          class="link"
          (action)="addWorkflow()" />
      </tidy-row>
      <!--<tidy-alert>
      <form [formGroup]="triggerForm" novalidate action="#">
        <tidy-row class="extra-bottom-padding" style="padding-bottom:0px">
          <tidy-input
            #searchInput
            label="Search"
            icon="assets/ionic-icon-v3/ios-search-outline.svg"
            activeIcon="src/assets/ionic-icon-v3/ios-search-outline.svg"
            [form]="triggerForm.get('search')"
            (keyup)="searchWorkflows(searchInput.value)"
            formControlName="search"
            class="title-input">
          </tidy-input>
        </tidy-row>
      </form>
    </tidy-alert>-->
    @for (workflow of filteredWorkflows; track workflow; let i = $index) {
      <tidy-card>
        <tidy-card-button (click)="goToWorkFlow(workflow)" class="no-below-stroke">
          <tidy-row class="vertical-align-center">
            <tidy-toggle
              style="margin-right: 20px"
              [toggled]="!workflow.paused_at"
              (toggleChanged)="pauseUnpauseWorkflow(workflow)"
              (click)="$event.stopPropagation()" />
            @if (workflow?.published_version?.workflow_version_trigger?.icon_url) {
              <div style="margin-right: 20px">
                @if (workflow?.published_version?.workflow_version_trigger?.icon_url) {
                  <tidy-image
                    [src]="workflow?.published_version?.workflow_version_trigger?.icon_url"
                    style="width:25px" />
                }
                @for (action of workflow?.published_version?.workflow_version_actions; track action) {
                  <tidy-image
                    [src]="action?.icon_url"
                    style="width:25px" />
                }
              </div>
            }
            @if (workflow?.draft_version?.workflow_version_trigger?.icon_url && !workflow?.published_version?.workflow_version_trigger?.icon_url) {
              <div style="margin-right: 20px">
                @if (workflow?.draft_version?.workflow_version_trigger?.icon_url) {
                  <tidy-image
                    [src]="workflow?.draft_version?.workflow_version_trigger?.icon_url"
                    style="width:25px" />
                }
                @for (action of workflow?.draft_version?.workflow_version_actions; track action) {
                  <tidy-image
                    [src]="action?.icon_url"
                    style="width:25px" />
                }
              </div>
            }
            <tidy-text
              [body]="workflow.name" />
          </tidy-row>
          <div>
          </div>
        </tidy-card-button>
      </tidy-card>
    }
    @if (filteredWorkflows.length === 0) {
      <tidy-alert class="empty-list-alert">
        <tidy-row [align]="'center'">
          <tidy-text
            helper="No Workflows Added" />
        </tidy-row>
      </tidy-alert>
    }
    <tidy-row>
      <tidy-text
        [header]="'Templates'" />
    </tidy-row>
    @for (template of workflowTemplates; track template) {
      <tidy-card>
        <tidy-row class="no-padding" [alignLastItemRight]="true">
          <tidy-text
            [header]="template?.name" />
          <tidy-text
            [actionBody]="'Add'"
            class="link"
            (action)="addTemplate(template?.id)" />
        </tidy-row>
        <tidy-row class="extra-bottom-padding">
          <tidy-text
            [body]="template?.description" />
        </tidy-row>
        <tidy-row class="vertical-align-center">
          <tidy-image
            [src]="'assets/img/play.svg'"
            class="body-size" />
          <tidy-text
            [header]="'Trigger:'" />
        </tidy-row>
        <tidy-row class="vertical-align-middle">
          <tidy-image
            [src]="template?.trigger?.icon_url" />
          <tidy-text
            [body]="template?.trigger?.name + ' - ' + template?.trigger?.description" />
        </tidy-row>
        <tidy-row class="vertical-align-center">
          <tidy-image
            [src]="'assets/img/check.svg'"
            class="body-size" />
          <tidy-text
            [header]="'Actions:'" />
        </tidy-row>
        @for (action of template?.workflow_template_actions; track action) {
          <tidy-row class="vertical-align-middle">
            <tidy-image
              [src]="action?.action?.icon_url" />
            <tidy-text
              [body]="action?.action?.name + ' - ' + action?.action?.description" />
          </tidy-row>
        }
      </tidy-card>
    }
  }

  @if (!loaded) {
    <tidy-row>
      <ion-item>
        <ion-skeleton-text animated slot="start" style="width: 19%; height: 16px" />
        <ion-skeleton-text animated slot="end" style="width: 17%; height: 16px" />
      </ion-item>
    </tidy-row>
    @for (item of [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20]; track item) {
      <tidy-card>
        <tidy-card-button (action)="goToWorkflowRunPage(run)">
          <tidy-row class="vertical-align-middle" [alignLastItemRight]="true">
            <div style="width:35%">
              <ion-skeleton-text animated style="height: 20px" />
            </div>
            <div>
            </div>
          </tidy-row>
        </tidy-card-button>
      </tidy-card>
    }
  }

</tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
